import apiService from './api.service';

export default {
  async checkUniqueness(
    query: Record<string, string | number | undefined> = {},
  ): Promise<Array<{ id: number }>> {
    let queryText = '';
    Object.keys(query).forEach((q) => {
      if (query[q] && query[q] !== '') {
        if (queryText.length > 0 && queryText.slice(-1) !== '&') {
          queryText += '&';
        }
        queryText += q + '=' + encodeURIComponent(query[q] as string | number);
      }
    });
    return (
      await apiService.get('locations/verify-uniqueness.json?' + queryText)
    ).data.data;
  },
};
